import React from 'react'

import { GrHostMaintenance, GrVmMaintenance } from "react-icons/gr";
import { GiAutoRepair } from "react-icons/gi";
import { FcInspection } from "react-icons/fc";
import { GrCertificate } from "react-icons/gr";
import { FaCheckCircle } from "react-icons/fa";
import { MdCurrencyExchange } from "react-icons/md";
const Hydrant = () => {
  return (
    <div class='hyd-div1'>
        <div class='hyd-div'>
            {/* <h1 class='hyd-h'>Fire Hydrant Works</h1> */}
        </div>
        <div class='container'>
            <div class='row mt-5'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                    
                    <GrHostMaintenance class='hyd-icon' />
                    <h4>Installation</h4>
                    <p>Fire hydrant installation involves setting up hydrants at strategic locations to ensure quick access to water during fire emergencies.</p>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                    <GrVmMaintenance class='hyd-icon'/>
                    <h4>Maintenance</h4>
                    <p>Proper maintenance helps extend the lifespan of hydrants and guarantees reliable water flow when needed.</p>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                    <GiAutoRepair class='hyd-icon'/>
                    <h4>Repair</h4>
                    <p>Fire hydrant repair involves fixing damaged or malfunctioning components to restore proper operation.</p>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3 hyd-ro p-2'>
                    <FcInspection class='hyd-icon'/>
                    <h4>Inspections</h4>
                    <p>Fire hydrant inspections involve routine checks to ensure the system is in proper working condition.</p>
                </div>
            </div>
        </div>
        <div class='container'>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6 mt-5'>
                    <img src='./Images/hyd.jpg' alt='' class='hyd-img1'/>
                </div>
                <div class='col-12 col-sm-12 col-md-6 col-lg-6 mt-5'>
                    <h3 class='hyd-hh1'>About Us</h3>
                    <h2 class='hyd-hh'>Experts In Fire Hydrant System</h2>
                    <p class='hyd-pp'>Our team of experts in fire hydrant systems brings extensive experience in designing, installing, and maintaining reliable fire protection solutions. With in-depth knowledge of safety standards and system requirements, we ensure every hydrant operates efficiently during emergencies. From planning and installation to regular maintenance and repairs, our professionals are committed to delivering high-quality, dependable services that protect lives and property.They use advanced tools and proven techniques to ensure every system meets quality and compliance requirements. Their commitment to timely service and attention to detail ensures maximum safety and long-term reliability.</p>
                </div>
            </div>
        </div>
        <div class='hyd-div3 mt-5'>
            <div class='container'>
            <div class='row'>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <h2 class='hyd-para'>Why <br></br>Choose Us?</h2>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <p><GrCertificate class='ico-hyd'/><span class='hyd-para ms-2'>Certified Technicans</span></p>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <p><FaCheckCircle class='ico-hyd'/><span class='hyd-para ms-2'>Quality<br></br> Guarantee</span></p>
                </div>
                <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                    <p><MdCurrencyExchange class='ico-hyd'/><span class='hyd-para ms-2'>Affordable Pricing</span></p>
                </div>
            </div>
            </div>
        </div>
        <div class='container'>
            <div class='row mt-5'>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                <h4 class='hyd-1'>PROJECTS</h4>
                <p class='hyd-2'>Our fire hydrant projects are executed with precision and a strong focus on safety and reliability. From initial planning and system design to installation and final testing, each project is carried out to meet industry standards and client requirements.</p>
                <button class='hyd-bt p-1'>View All Projects</button>
             </div>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                <img src='./Images/img1.png' alt='' class='hyd-im' />
             </div>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                <img src='./Images/img3.png' alt='' class='hyd-im' />
             </div>
             <div class='col-12 col-sm-12 col-md-12 col-lg-3'>
                <img src='./Images/img4.png' alt='' class='hyd-im' />
             </div>
            </div>
        </div>
        <div class='container'>
        <div class='row mt-4'>
            <h3 class='annual-hh3'>📞 Get in Touch</h3>
            <p class='annual-para12'>👉 Contact us today for All your Fire Hydrant needs.</p>
            <button class="button">Get in touch</button>
        </div>
        </div>
    </div>
  )
}

export default Hydrant